// src/components/mantenciones/SeverityPicker.jsx
import React from 'react';
import { theme } from 'antd';
import { SEVERIDAD_OPTIONS } from './maintenanceColors';

const { useToken } = theme;

// 4 chips de severidad con pip de color. Seleccionado => relleno con su color.
function SeverityPicker({ value, onPick }) {
  const { token } = useToken();
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 6 }}>
      {SEVERIDAD_OPTIONS.map((o) => {
        const on = value === o.value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onPick(o.value)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 5,
              padding: '8px 2px',
              borderRadius: token.borderRadius,
              border: `1px solid ${on ? 'transparent' : token.colorBorder}`,
              background: on ? o.color : token.colorBgContainer,
              color: on ? '#fff' : token.colorTextSecondary,
              fontWeight: 600,
              fontSize: 12,
              cursor: 'pointer',
              transition: `all ${token.motionDurationMid}`,
            }}
          >
            <span
              style={{
                width: 18,
                height: 5,
                borderRadius: 3,
                background: on ? 'rgba(255,255,255,.85)' : o.color,
              }}
            />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default SeverityPicker;
